import React from 'react'
import {
  AlignItems,
  Box,
  Button,
  Color,
  Display,
  FontWeight,
  FlexDirection,
  Heading6,
  JustifyContent,
  Paragraph,
  Space,
  Text,
  TextAlign,
  BorderStyle,
  BoxProps,
} from '@gousto-internal/citrus-react'
import { workingHours } from '../../config/workingHours'
import { externalGoustoPages } from '../../config/routes'
import { HelpCentre } from '../../common/tracking'

type Props = {
  isStandalone?: boolean
  query: string
}

const NoSearchResult = ({ isStandalone = false, query }: Props) => {
  const boxProps: BoxProps = isStandalone ? {
    borderStyle: BorderStyle.Solid,
    borderColor: Color.ColdGrey_100,
    bg: Color.White,
    borderWidth: 0.5,
    paddingV: 20,
  } : {
    paddingV: 10,
  }

  return (
    <Box
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      justifyContent={JustifyContent.Center}
      alignItems={AlignItems.Center}
      height="100%"
      paddingH={6}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...boxProps}
    >
      <Heading6
        color={Color.ColdGrey_900}
        fontWeight={FontWeight.SemiBold}
        size={3}
        textAlign={TextAlign.Center}
      >
        There were no results for your search
      </Heading6>
      <Space size={3} />
      <Paragraph
        size={2}
        textAlign={TextAlign.Center}
        color={Color.NeutralGrey_600}
      >
        If you still need help with your enquiry, contact our customer care team.
      </Paragraph>
      <Space size={4} />
      <Button
        width="100%"
        maxWidth="12rem"
        onClick={() => window.location.assign(externalGoustoPages.contactUs)}
        data-tracking-action={HelpCentre.HELP_CENTRE_SEARCH_CONTACT_US}
        data-tracking-property={JSON.stringify({ search_term: query })}
      >
        Contact us
      </Button>
      <Space size={4} />
      <Text
        size={1}
        color={Color.NeutralGrey_600}
        textAlign={TextAlign.Center}
      >
        {workingHours.weekdays}
      </Text>
      <Text
        size={1}
        color={Color.NeutralGrey_600}
        textAlign={TextAlign.Center}
      >
        {workingHours.weekend}
      </Text>
    </Box>
  )
}

export { NoSearchResult }
